import React from "react";
import { Redirect, RedirectProps } from "react-router-dom";
import { PermissionProps } from "../Model/Permission";
import { getUserCredential } from "../redux/reducers/LocalUserReducer";
import { useTypedSelector } from "../redux/reducers/RootReducer";
import PermissionUtil from "../Utility/PermissionUtil";
import { usePermission } from "./Common/PermissionProvider";

interface PrivateRedirectProps extends RedirectProps, PermissionProps {additonalRule?: boolean}

const PrivateRedirect = ({ to, permissions, componentId, additonalRule, ...rest }: PrivateRedirectProps) => {
  const user = useTypedSelector((state) => getUserCredential(state));
  let canReadComponent =
    permissions && componentId ? PermissionUtil.canReadComponent(permissions, componentId) : true;
  
  canReadComponent = additonalRule ? additonalRule && canReadComponent : canReadComponent;
  return canReadComponent ? (
    <Redirect to={to} {...rest} />
  ): (null)
};

export default usePermission(PrivateRedirect);
